// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: 6okmavSCY4v

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSmallOverlayMenu.module.css"; // plasmic-import: 6okmavSCY4v/css

import MenuIconIcon from "./icons/PlasmicIcon__MenuIcon"; // plasmic-import: 6ypUPjJsyj/icon

createPlasmicElementProxy;

export type PlasmicSmallOverlayMenu__VariantMembers = {
  view: "seeAllView" | "sectionView" | "publicSectionView";
  inactive: "inactive";
  color: "dark" | "light" | "inactive";
};
export type PlasmicSmallOverlayMenu__VariantsArgs = {
  view?: SingleChoiceArg<"seeAllView" | "sectionView" | "publicSectionView">;
  inactive?: SingleBooleanChoiceArg<"inactive">;
  color?: SingleChoiceArg<"dark" | "light" | "inactive">;
};
type VariantPropType = keyof PlasmicSmallOverlayMenu__VariantsArgs;
export const PlasmicSmallOverlayMenu__VariantProps = new Array<VariantPropType>(
  "view",
  "inactive",
  "color"
);

export type PlasmicSmallOverlayMenu__ArgsType = {};
type ArgPropType = keyof PlasmicSmallOverlayMenu__ArgsType;
export const PlasmicSmallOverlayMenu__ArgProps = new Array<ArgPropType>();

export type PlasmicSmallOverlayMenu__OverridesType = {
  menuButton?: p.Flex<"button">;
  localHeaderSubmenu?: p.Flex<typeof p.PlasmicImg>;
  svg?: p.Flex<"svg">;
};

export interface DefaultSmallOverlayMenuProps {
  view?: SingleChoiceArg<"seeAllView" | "sectionView" | "publicSectionView">;
  inactive?: SingleBooleanChoiceArg<"inactive">;
  color?: SingleChoiceArg<"dark" | "light" | "inactive">;
  className?: string;
}

const $$ = {};

function PlasmicSmallOverlayMenu__RenderFunc(props: {
  variants: PlasmicSmallOverlayMenu__VariantsArgs;
  args: PlasmicSmallOverlayMenu__ArgsType;
  overrides: PlasmicSmallOverlayMenu__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "view",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.view
      },
      {
        path: "inactive",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.inactive
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <button
      data-plasmic-name={"menuButton"}
      data-plasmic-override={overrides.menuButton}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.menuButton,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.menuButtoncolor_dark]: hasVariant($state, "color", "dark"),
          [sty.menuButtoncolor_inactive]: hasVariant(
            $state,
            "color",
            "inactive"
          ),
          [sty.menuButtoncolor_light]: hasVariant($state, "color", "light"),
          [sty.menuButtoninactive]: hasVariant($state, "inactive", "inactive"),
          [sty.menuButtonview_publicSectionView]: hasVariant(
            $state,
            "view",
            "publicSectionView"
          ),
          [sty.menuButtonview_sectionView]: hasVariant(
            $state,
            "view",
            "sectionView"
          ),
          [sty.menuButtonview_seeAllView]: hasVariant(
            $state,
            "view",
            "seeAllView"
          )
        }
      )}
      disabled={hasVariant($state, "inactive", "inactive") ? true : false}
      ref={ref => {
        $refs["menuButton"] = ref;
      }}
    >
      {(
        hasVariant($state, "color", "light")
          ? true
          : hasVariant($state, "view", "publicSectionView")
          ? false
          : hasVariant($state, "view", "seeAllView")
          ? true
          : true
      ) ? (
        <p.PlasmicImg
          data-plasmic-name={"localHeaderSubmenu"}
          data-plasmic-override={overrides.localHeaderSubmenu}
          alt={""}
          className={classNames(sty.localHeaderSubmenu, {
            [sty.localHeaderSubmenucolor_dark]: hasVariant(
              $state,
              "color",
              "dark"
            ),
            [sty.localHeaderSubmenucolor_inactive]: hasVariant(
              $state,
              "color",
              "inactive"
            ),
            [sty.localHeaderSubmenucolor_light]: hasVariant(
              $state,
              "color",
              "light"
            ),
            [sty.localHeaderSubmenuinactive]: hasVariant(
              $state,
              "inactive",
              "inactive"
            ),
            [sty.localHeaderSubmenuview_publicSectionView]: hasVariant(
              $state,
              "view",
              "publicSectionView"
            ),
            [sty.localHeaderSubmenuview_seeAllView]: hasVariant(
              $state,
              "view",
              "seeAllView"
            )
          })}
          displayHeight={"auto"}
          displayMaxHeight={"1.56em"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"1.25em"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/715be8d74ced46d5a0b0004b5bd87995.svg",
            fullWidth: 4.451,
            fullHeight: 21.999,
            aspectRatio: 0.227273
          }}
        />
      ) : null}
      <MenuIconIcon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        className={classNames(projectcss.all, sty.svg, {
          [sty.svgcolor_light]: hasVariant($state, "color", "light")
        })}
        role={"img"}
      />
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  menuButton: ["menuButton", "localHeaderSubmenu", "svg"],
  localHeaderSubmenu: ["localHeaderSubmenu"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  menuButton: "button";
  localHeaderSubmenu: typeof p.PlasmicImg;
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSmallOverlayMenu__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSmallOverlayMenu__VariantsArgs;
    args?: PlasmicSmallOverlayMenu__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSmallOverlayMenu__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSmallOverlayMenu__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSmallOverlayMenu__ArgProps,
          internalVariantPropNames: PlasmicSmallOverlayMenu__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSmallOverlayMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "menuButton") {
    func.displayName = "PlasmicSmallOverlayMenu";
  } else {
    func.displayName = `PlasmicSmallOverlayMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicSmallOverlayMenu = Object.assign(
  // Top-level PlasmicSmallOverlayMenu renders the root element
  makeNodeComponent("menuButton"),
  {
    // Helper components rendering sub-elements
    localHeaderSubmenu: makeNodeComponent("localHeaderSubmenu"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicSmallOverlayMenu
    internalVariantProps: PlasmicSmallOverlayMenu__VariantProps,
    internalArgProps: PlasmicSmallOverlayMenu__ArgProps
  }
);

export default PlasmicSmallOverlayMenu;
/* prettier-ignore-end */
